import { Check, Play, Send } from 'lucide-react'

export function InvokeIcon({ icon }: { icon?: string }) {
  // TODO: Design to pixel peep and add more icons
  if (icon === 'send') {
    // 14px @ 2.25 matches the ~1.3px stroke of the 16px/2 hover-cluster icons
    // beside it (archive).
    return <Send className="size-3.5 opacity-80" strokeWidth={2.25} />
  }

  // Matches `getActionIcon`'s handling of the same sentinel, which badges the
  // card with a check — without this the button fell through to Play.
  if (icon === 'check') {
    return <Check className="size-2.5 opacity-80" strokeWidth={2.5} />
  }

  return <Play fill="currentColor" className="size-2 opacity-80" />
}
